import {
    FindAgentsResultsPage,
    getServerSideProps
} from '@zoopla/find-agents-results';

export default FindAgentsResultsPage;
export { getServerSideProps };
